import { Alert, Icons } from '@commenda/kakashi';
import { VALIDATION_MESSAGES } from '../../constants';
import { FilingPreviewEntry } from '../../types';

interface FiledConflictAlertProps {
  conflictingFilings: FilingPreviewEntry[];
}

export function FiledConflictAlert({
  conflictingFilings,
}: FiledConflictAlertProps) {
  if (!conflictingFilings || conflictingFilings.length === 0) return null;

  return (
    <Alert
      variant="destructive"
      icon={<Icons.AlertCircle className="size-5 text-text-error" />}
      title="Filed conflict detected"
      description={VALIDATION_MESSAGES.FILED_CONFLICT}
    />
  );
}
